export default __webpack_public_path__ + "static/media/2s.cb65eca8.svg";